<template>
  <div>
    <div class="image-cropper">
      <img :src="original"
           v-crop
           alt="cropper target">
    </div>
    <div class="d-flex justify-content-around">
      <div v-if="src" class="ma-4 d-flex flex-column align-items-center">
        <span>修改前</span>
        <img class="image-cropper__before mt-2"
             :src="src"
             v-stream:load="onImageLoad$"
        >
      </div>
      <div class="ma-4 d-flex flex-column align-items-center">
        <span>預覽</span>
        <div class="image-cropper__preview mt-2" ref="preview"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  pluck,
  map,
  tap,
  distinctUntilChanged,
} from 'rxjs/operators';
import Cropper from 'cropperjs';
import vModelMixin from '../../mixins/v-model';

export default {
  name: 'ImageCropper',
  mixins: [vModelMixin],
  props: {
    original: String,
    src: String,
    disabled: Boolean,
  },
  data: () => ({
    cropper: null,
  }),
  watch: {
    disabled(val) {
      if (val) {
        this.cropper.disable();
      } else {
        this.cropper.enable();
      }
    },
  },
  directives: {
    crop: {
      inserted(el, _, { context }) {
        context.cropper = new Cropper(el, {
          viewMode: 1,
          autoCropArea: 1,
          aspectRatio: context.aspectRatio,
          preview: context.$refs.preview,
          crop({ detail }) {
            context.inputVal = detail;
          },
        });
      },
    },
  },
  domStreams: ['onImageLoad$'],
  subscriptions() {
    return {
      aspectRatio: this.onImageLoad$
        .pipe(
          pluck('event', 'path', 0),
          map(({ width, height }) => width / height),
          distinctUntilChanged(),
          tap((val) => {
            this.cropper.setAspectRatio(val);
            this.cropper.reset();
          }),
        ),
    };
  },
};
</script>

<style scoped lang="scss">
.image-cropper {
  width: 100%;
  height: 50vh;
  overflow: hidden;

  & img {
    max-width: 100%;
  }

  &__preview, &__before {
    border: 1px solid #cdcdcd;
  }

  &__preview {
    width: 20vh;
    height: 20vh;
    overflow: hidden;
  }

  &__before {
    width: 20vh;
  }
}
</style>

<style lang="scss">
@import "~cropperjs/dist/cropper.min.css";

.cropper-bg {
  background-repeat: repeat;
}
</style>
